import { useState } from "react";
import styled from "styled-components";
  const PhoneFrame = styled.div`
    position: relative;
    width: 90vw;
    max-width: 800px;
    aspect-ratio: 16 / 9;
    border: 0.5vw solid #333;
    border-radius: 6vw;
    background-color: #000;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    overflow: hidden;
    margin: 20px auto;
    @media (max-width: 600px) {
      border: 1vw solid #333;
    }
  `;
export default function ClickToPlayVideo() {
  const [isPlaying, setIsPlaying] = useState(false);


  const thumb786 = "https://i.vimeocdn.com/video/2021758664-4970af78d1946fab664c10ddc5970555c025a8a07577b1656889fb5c8b06a487-d?mw=786&mh=442";
/*   const thumbnailUrl =
    "https://i.vimeocdn.com/video/2021758664-4970af78d1946fab664c10ddc5970555c025a8a07577b1656889fb5c8b06a487-d?mw=1100&mh=618"; */

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "20px",
        margin: 10,
      }}
    >
      <PhoneFrame>
        <div style={{ padding: "56.27% 0 0 0", position: "relative" }}>
          {!isPlaying ? (
            <>
              <img
                src={thumb786}
                alt="Play video"
                fetchpriority="high"
                onClick={handlePlay}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  cursor: "pointer",
                  borderRadius: 10,
                }}
              />
              <button
                onClick={handlePlay}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  width: 60,
                  height: 60,
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                ▶
              </button>
            </>
          ) : (
            <iframe
              title="Recite And Upload"
              src="https://player.vimeo.com/video/1084872193?autoplay=1&dnt=1"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                margin: 0,
                borderRadius: 10,
                width: "100%",
                height: "100%",
              }}
            />
          )}
        </div>
      </PhoneFrame>
    </div>
  );
}
